import React,{useEffect} from 'react'

import axios from 'axios';

function AppWraper(props) {
  
  

  return (
    <div className='main-container-wrap'>
      <div className={props.customCss?'main-container '+props.customCss:'main-container '} >
        {props.layout}
      </div>
    </div>
  );
}

export default AppWraper